const ATTEMPT_STAGE_LABELS = Object.freeze({
  Queued: '等待执行',
  Assigned: '等待执行',
  GeneratingDraft: '生成草稿',
  DraftReady: '等待导出',
  Exporting: '导出',
  Exported: '等待上传',
  Uploading: '上传',
});

const DRAFT_ERROR_CODES = new Set([
  'template_not_found',
  'template_unreadable',
  'invalid_template_path',
  'draft_already_exists',
  'invalid_replacement',
  'draft_download_failed',
  'audio_download_failed',
  'video_download_failed',
  'draft_publish_failed',
  'draft_filesystem_error',
  'draft_create_failed',
]);

const EXPORT_ERROR_CODES = new Set([
  'export_busy',
  'draft_not_found',
  'invalid_export_request',
  'foreground_activation_failed',
  'editor_window_not_found',
  'link_media_dialog_failed',
  'jianying_interaction_failed',
  'export_timeout',
  'export_failed',
]);

const inferLegacyAttemptStage = (attempt) => {
  const errorCode = String(attempt?.error_code || '');
  if (errorCode === 'oss_upload_failed' || errorCode.includes('upload')) {
    return 'Uploading';
  }
  if (EXPORT_ERROR_CODES.has(errorCode) || errorCode.startsWith('export_')) {
    return 'Exporting';
  }
  if (DRAFT_ERROR_CODES.has(errorCode)) {
    return 'GeneratingDraft';
  }
  if (attempt?.status === 'Success') {
    return 'Uploading';
  }
  return '';
};

export const getJianyingAttemptStageLabel = (attempt = {}) => {
  const recordedStage = String(attempt.stage || '');
  const stage = ATTEMPT_STAGE_LABELS[recordedStage]
    ? recordedStage
    : inferLegacyAttemptStage(attempt);
  return ATTEMPT_STAGE_LABELS[stage] || '未记录';
};

export const shouldDefaultExpandJianyingAttemptCycle = (attempts) =>
  (Array.isArray(attempts) ? attempts : [])
    .some((attempt) => attempt?.status !== 'Success');
